<template>
  <v-app class="bg-gradient">
    <div class="auth-container">
      <div class="main-lang-container" id="lang-container-id">
        <div class="lang-container">
          <v-select
            @change="changeLanguage"
            dense
            solo
            :items="languages"
            v-model="lang"
            prepend-icon="fas fa-globe"
            item-text="name"
            item-value="id">
          </v-select>
        </div>
      </div>
      <router-view
        :lang="lang">
      </router-view>
    </div>
  </v-app>
</template>

<script>
  export default {
    data () {
      return {
        languages: [
          {
            name: 'English',
            id: 'en'
          },
          {
            name: 'Español',
            id: 'es'
          }
        ],
        lang: 'es'
      }
    },
    mounted () {
      this.moveLangContainer()
      window.addEventListener('resize', this.moveLangContainer)
    },
    watch: {
      // eslint-disable-next-line
      $route (to, from) {
        setTimeout(() => {
          this.moveLangContainer()
        }, 500)
      }
    },
    methods: {
      changeLanguage () {
        this.$i18n.locale = this.lang
        this.$vuetify.lang.current = this.lang
      },
      moveLangContainer () {
        const appElement = document.getElementById('app')
        const cardElement = document.getElementById('card-auth-container')
        if (appElement && cardElement) {
          const appWidth = appElement.clientWidth
          const cardWidth = cardElement.clientWidth
          const space = (appWidth - ((appWidth - cardWidth) / 2)) - 170
          const langElement = document.getElementById('lang-container-id')
          langElement.style.marginLeft = space + 'px'
        }
      }
    }
  }
</script>

<style>
  .bg-gradient > .v-application--wrap {
    background-image: linear-gradient(to right, #36D1DC , #5B86E5);
    min-height: 100vh;
    align-items: center;
    display: grid;
  }
  .auth-container {
    align-items: center;
    display: grid;
  }
  .lang-container {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 160px;
  }
  .lang-container .fa-globe {
    color: white;
  }
  .lang-container .v-text-field__details {
    display: none;
  }
</style>
